import { BACKEND } from "../variables.js";
import axios from "axios";

const PREFILL_URL = BACKEND + "/subscriptionContracts/prefill";
const LIST_BY_SUB_URL = BACKEND + "/subscriptionContracts/listBySubscription";
const LIST_BY_TENANT_URL = BACKEND + "/subscriptionContracts/listByTenant";
const GET_URL = BACKEND + "/subscriptionContracts/get";
const ADD_URL = BACKEND + "/subscriptionContracts/add";
const UPDATE_URL = BACKEND + "/subscriptionContracts/update";
const ISSUE_URL = BACKEND + "/subscriptionContracts/issue";
const SIGN_URL = BACKEND + "/subscriptionContracts/markSigned";
const TERMINATE_URL = BACKEND + "/subscriptionContracts/terminate";
const DELETE_URL = BACKEND + "/subscriptionContracts/delete";
const DOWNLOAD_PDF_URL = BACKEND + "/subscriptionContracts/downloadPdf";

const post = (url, payload) =>
  axios({
    method: "POST",
    url,
    data: payload.data,
    headers: { Authorization: payload.token },
  });

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    PREFILL_CONTRACT(_, payload) {
      return post(PREFILL_URL, payload);
    },
    LIST_CONTRACTS_BY_SUBSCRIPTION(_, payload) {
      return post(LIST_BY_SUB_URL, payload);
    },
    LIST_CONTRACTS_BY_TENANT(_, payload) {
      return post(LIST_BY_TENANT_URL, payload);
    },
    GET_CONTRACT(_, payload) {
      return post(GET_URL, payload);
    },
    ADD_CONTRACT(_, payload) {
      return post(ADD_URL, payload);
    },
    UPDATE_CONTRACT(_, payload) {
      return post(UPDATE_URL, payload);
    },
    ISSUE_CONTRACT(_, payload) {
      return post(ISSUE_URL, payload);
    },
    SIGN_CONTRACT(_, payload) {
      return post(SIGN_URL, payload);
    },
    TERMINATE_CONTRACT(_, payload) {
      return post(TERMINATE_URL, payload);
    },
    DELETE_CONTRACT(_, payload) {
      return post(DELETE_URL, payload);
    },
    DOWNLOAD_CONTRACT_PDF(_, payload) {
      return axios({
        method: "POST",
        url: DOWNLOAD_PDF_URL,
        data: payload.data,
        headers: { Authorization: payload.token },
        responseType: "blob",
      });
    },
  },
};
